module.exports = __webpack_public_path__ + "static/media/galerija_2013 (20).3040c3b1.jpg";